import React, { useState, useContext, useMemo } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
} from "@mui/material";
import CompanySignupForm from "../Components/CompanySignupForm";
import { isMobile } from "react-device-detect";
import { UserDetailsContext } from "../Context/userDetailsContext";

const steps = ["بيانات الشركة", "المالكين", "المفوّضون", "المرفقات", "مراجعة وإرسال"];

const SignUpCompany = ({
  allowCurrentUserDelegate = false,
  currentUserDelegate = null,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const { userDetails } = useContext(UserDetailsContext);

  const autoCurrentUserDelegate = useMemo(() => {
    if (!userDetails?.isAuthenticated || userDetails?.type !== 3) {
      return null;
    }

    return {
      delegateId: userDetails.userId,
      documentNumber: userDetails.citizen?.documentNumber,
      fullName: userDetails.citizen?.fullName,
    };
  }, [userDetails]);

  const resolvedAllowCurrentUserDelegate = allowCurrentUserDelegate || Boolean(autoCurrentUserDelegate?.delegateId);
  const resolvedCurrentUserDelegate = currentUserDelegate || autoCurrentUserDelegate;

  return (
    <Box sx={{ padding: 3 }}>
      <Box sx={{ width: "100%" }}>
        <Stepper
          activeStep={activeStep}
          orientation={isMobile ? "vertical" : "horizontal"}
          sx={
            isMobile
              ? {
                  "& .MuiStepConnector-root": {
                    marginLeft: "auto",
                    marginRight: "8%",
                  },
                }
              : {
                  "& .MuiStepLabel-label": { marginRight: 1 },
                  "& .MuiStepLabel-iconContainer": { padding: 0 },
                }
          }
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <Box sx={{ my: 2 }}>
          <CompanySignupForm
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            stepsLength={steps.length}
            allowCurrentUserDelegate={resolvedAllowCurrentUserDelegate}
            currentUserDelegate={resolvedCurrentUserDelegate}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SignUpCompany;
